import Dropdown from 'react-bootstrap/Dropdown';
import DropdownDeprecated from './deprecated';

Dropdown.Deprecated = DropdownDeprecated;

export default Dropdown;
export { default as DropdownButton } from 'react-bootstrap/DropdownButton';
export { default as SplitButton } from 'react-bootstrap/SplitButton';
